import { MdArrowBackIos, MdNotifications } from 'react-icons/md';
import { formatDateStrToDate } from '../utils';
import { useNavigate } from 'react-router-dom';

function Notification() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/notifications');
  };

  function notification() {
    const notification = sessionStorage.getItem('notification');
    return notification !== null ? JSON.parse(notification) : goBack();
  }

  return (
    <section className='text-p-bk'>
      <div className='flex flex-row gap-3 justify-center items-center py-12 bg-f-bk mb-12 text-2xl '>
        <MdNotifications />
        <h2>Notifications</h2>
      </div>

      <div className='w-[90%] flex flex-col gap-6 items-start p-6 mx-auto'>
        <button
          className='flex flex-row gap-2 items-center hover:bg-f-bk p-2 [&>*]:hover:text-p-bk rounded-lg'
          onClick={() => {
            window.sessionStorage.removeItem('notification');
            goBack();
          }}
        >
          <i className='bg-f-bk px-2 py-2 rounded-md text-b-mc'>
            <MdArrowBackIos className='h-full w-full' />
          </i>
          <span className='text-b-mc text-base'>Back</span>
        </button>
        <div className='w-full flex flex-row gap-6 mx-auto'>
          <div className='py-2 w-full '>
            <div className='flex flex-row justify-between pb-4 border-b-hf mb-6 items-end'>
              <h3 className='font-semibold text-[18px]'>
                {notification()?.title}
              </h3>
              <span className='text-xs text-s-bk'>
                {formatDateStrToDate(notification()?.created_at)}
              </span>
            </div>

            <div className='flex flex-row gap-4  px-4 mb-4 py-4 w-full rounded  bg-p-wh text-s-bk'>
              <span className='px-4 py-2 rounded h-fit bg-orange-500 text-p-wh mt-1'>
                {notification()?.title?.split(' ')[0][0]}
              </span>
              <div className='w-full '>
                <h4 className='font-semibold flex justify-between items-center pb-2'>
                  {notification()?.title}
                </h4>
                <p className='text-sm '>{notification()?.message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Notification;
